import { ArrowHorizontalLockIcon } from './ArrowHorizontalLockIcon';

/**
 * author: Michael Irigoyen
 * id AE7BA87E-D5CF-415E-8641-ADE156760E93
 * name arrow-horizontal-lock
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-horizontal-lock.svg
 * tags
 * - Lock 
 * - Arrow 
 */
export const ScrollHorizontalLockIcon = ArrowHorizontalLockIcon;
export default ScrollHorizontalLockIcon